"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("TitleSelector");

var AccountActions = require("./AccountActions");
var AccountFormHelper = require("./AccountFormHelper");
var AccountStore = require("./AccountStore");
var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class AccountTitleSelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedTitle: props.initialValue || "",
			disabled: false
		};

		this._onChange = this._onChange.bind(this);
	}

	handleTitleSelected(event) {
		if (!event || !event.currentTarget) {
			return;
		}

		var selectedTitle = event.currentTarget.value;
		var formParentId = AccountFormHelper.getParentFormId(this);

		AccountActions.setSelectedTitle(formParentId, selectedTitle);
	}

	_onChange() {
		if (this._isMounted) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormId(this);

			var parentFormIdForUpdateAllowed = formParentId;
			if ($formParent.length > 0) {
				// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
				var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
				parentFormIdForUpdateAllowed = AccountFormHelper.getParentFormIdFromForm($parentFormForUpdateAllowed);
			}

			this.setState({
				disabled: formParentId ? AccountActions.getIsFormInputDisabled(parentFormIdForUpdateAllowed || formParentId) : false,
				selectedTitle: AccountActions.getSelectedTitle(formParentId) || ""
			});
		}
	}

	componentDidMount() {
		this._isMounted = true;

		var $formParent = AccountFormHelper.getParentForm(this);
		var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
		var updateAllowed = true;

		if ($formParent.length > 0) {
			// updateAllowed applies to this selector when inside the createAccountForm or when inside the eventRegistration component (could be within a createAccountForm or spouseInformation)
			var $parentFormForUpdateAllowed = $formParent.is("[data-component='createAccountForm']") ? $formParent : $formParent.closest("[data-component='eventRegistration']").find("[data-component='createAccountForm']");
			updateAllowed = !$parentFormForUpdateAllowed.length || $parentFormForUpdateAllowed.is("[data-update-allowed]");
		}

		AccountActions.setSelectedTitle(formParentId, this.state.selectedTitle);
		AccountStore.addChangeListener(this._onChange);
		AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
	}

	componentWillUnmount() {
		AccountStore.removeChangeListener(this._onChange);
		if (this.props.isDesignMode) {
			var $formParent = AccountFormHelper.getParentForm(this);
			var formParentId = AccountFormHelper.getParentFormIdFromForm($formParent);
			var updateAllowed = true;

			if ($formParent.length > 0) {
				updateAllowed = $formParent.is("[data-update-allowed]");
			}

			AccountActions.setSelectedTitle(formParentId, null);
			AccountActions.toggleInputStatus(formParentId, /*disabled*/ !updateAllowed);
		}

		this._isMounted = false;
	}

	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				config={this.props.titleConfig}
				onChange={this.handleTitleSelected.bind(this)}
				wizard={AccountStore.get("wizardAccountTitles")}
				wizardValuesKey="availableTitles"
				configKey="availableTitles"
				reactComponentName="AccountTitleSelector"
				selectClassName="account-title-selector"
				optionsClassName="availableTitle"
				selectNameAttribute="title"
				initialValue={this.state.selectedTitle}
				disabled={this.state.disabled}
			/>
		);
	}
}

AccountTitleSelector.propTypes = {
	isDesignMode: PropTypes.bool,
	titleConfig: PropTypes.object,
	required: PropTypes.bool,
	theme: PropTypes.string,
	context: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	childClass: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	reactComponentCategory: PropTypes.string,
	dataChildOf: PropTypes.string
};

module.exports = AccountTitleSelector;
